module.exports = __webpack_public_path__ + "img/3.6c3e7f7d.jpg";